/**
 * An error object that represents an API error sent by the backend
 */
export default class extends Error {
  constructor({ code, error_code, errors, message, status, title }, ...params) {
    super(...params)

    this.name = 'API Error'
    this.code = code
    this.message = message
    this.status = status
    // Validation failures (400) carry a per-field map of messages.
    this.errorCode = error_code
    this.errors = errors
    this.title = title
  }
}
